import React from 'react';
import {useState, useEffect} from 'react'
import Square from "./square";

const INITIAL_GAME_STATE = ["", "", "", "", "", "", "", "", ""];

const WINNING_COMBINATIONS = [
    // Horizontal
    [0, 1, 2],
    [3, 4, 5],
    [6, 7, 8],
    // Vertical
    [0, 3, 6],
    [1, 4, 7],
    [2, 5, 8],
    // Diagonal
    [0, 4, 8],
    [2, 4, 6],
    ];

function TicTacToe() {
  const [gameState, setGameState] = useState(INITIAL_GAME_STATE);
  const [currentPlayer, setCurrentPlayer] = useState("X");
  useEffect(() => {
      if (gameState === INITIAL_GAME_STATE) {
          return
      }
      checkForWinner()
      // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [gameState])

    const resetBoard = () => setGameState(INITIAL_GAME_STATE)


   const  handleWin = () => {
     window.alert(`Congrats ${currentPlayer}! You won!`)
       resetBoard()
   }

   const handleTie = () => {
     window.alert("It's a tie!")
       resetBoard()
   }

  const checkForWinner = () => {
    let roundWon = false;

    for (let index = 0; index < WINNING_COMBINATIONS.length; index++) {
      const winCondition = WINNING_COMBINATIONS[index];

      let a = gameState[winCondition[0]];
      let b = gameState[winCondition[1]];
      let c = gameState[winCondition[2]];

      if ([a,b,c].includes("")) {
        continue
      }

      if (a === b && b === c) {
        roundWon = true;
        break
      }
    }

    if (roundWon) {
      setTimeout(() => handleWin(), 500)
      return
    }

    if (!gameState.includes("")) {
      setTimeout(() => handleTie(), 500)
      return
    }

    changePlayer()
  }

  const changePlayer = () => {
    setCurrentPlayer(currentPlayer === "X" ? "O" : "X")
  }

  const handleCellClick = (event: any) => {
    const cellIndex = Number(event.target.getAttribute("data-cell-index"))

    const currentValue = gameState[cellIndex];
    if (currentValue) {
      return
    }

    const newValues = [...gameState]
    newValues[cellIndex] = currentPlayer
    setGameState(newValues)
  }

  return (
    <div className="bg-gradient-to-r from-blue-950 to-blue-500">
      <h1 className="text-center font-extrabold text-3xl text font-sans p-8">Tic Tac Toe!</h1>
        <div className="grid grid-cols-3 gap-3 mx-auto w-96">
          {gameState.map((player, index) => (
              <Square key={index} onClick={handleCellClick} {...{index, player}}/>
          ))}
        </div>
    </div>
  );
}

export default TicTacToe;
